import { getLanguageFormatted } from "../../../utils/i18nLanguage";

const label = (es, en, pt) => ({ es, en, pt });

export const GOOGLE_ADS_APP_CATEGORY_LABELS = {
  69500: label("Todas las apps", "All apps", "Todos os apps"),
  60000: label("Google Play", "Google Play", "Google Play"),
  60001: label(
    "Google Play / Libros y referencia",
    "Google Play / Books & Reference",
    "Google Play / Livros e referência"
  ),
  60002: label(
    "Google Play / Negocios",
    "Google Play / Business",
    "Google Play / Negócios"
  ),
  60003: label(
    "Google Play / Cómics",
    "Google Play / Comics",
    "Google Play / Quadrinhos"
  ),
  60004: label(
    "Google Play / Comunicación",
    "Google Play / Communication",
    "Google Play / Comunicação"
  ),
  60005: label(
    "Google Play / Educación",
    "Google Play / Education",
    "Google Play / Educação"
  ),
  60006: label(
    "Google Play / Entretenimiento",
    "Google Play / Entertainment",
    "Google Play / Entretenimento"
  ),
  60007: label(
    "Google Play / Finanzas",
    "Google Play / Finance",
    "Google Play / Finanças"
  ),
  60008: label(
    "Google Play / Juegos",
    "Google Play / Games",
    "Google Play / Jogos"
  ),
  60009: label(
    "Google Play / Salud y fitness",
    "Google Play / Health & Fitness",
    "Google Play / Saúde e fitness"
  ),
  60010: label(
    "Google Play / Bibliotecas y demos",
    "Google Play / Libraries & Demo",
    "Google Play / Bibliotecas e demos"
  ),
  60011: label(
    "Google Play / Estilo de vida",
    "Google Play / Lifestyle",
    "Google Play / Estilo de vida"
  ),
  60013: label(
    "Google Play / Reproductores y editores de video",
    "Google Play / Video Players & Editors",
    "Google Play / Reprodutores e editores de vídeo"
  ),
  60014: label(
    "Google Play / Medicina",
    "Google Play / Medical",
    "Google Play / Medicina"
  ),
  60015: label(
    "Google Play / Música y audio",
    "Google Play / Music & Audio",
    "Google Play / Música e áudio"
  ),
  60016: label(
    "Google Play / Noticias y revistas",
    "Google Play / News & Magazines",
    "Google Play / Notícias e revistas"
  ),
  60017: label(
    "Google Play / Personalización",
    "Google Play / Personalization",
    "Google Play / Personalização"
  ),
  60018: label(
    "Google Play / Fotografía",
    "Google Play / Photography",
    "Google Play / Fotografia"
  ),
  60019: label(
    "Google Play / Productividad",
    "Google Play / Productivity",
    "Google Play / Produtividade"
  ),
  60020: label(
    "Google Play / Compras",
    "Google Play / Shopping",
    "Google Play / Compras"
  ),
  60021: label(
    "Google Play / Social",
    "Google Play / Social",
    "Google Play / Social"
  ),
  60022: label(
    "Google Play / Deportes",
    "Google Play / Sports",
    "Google Play / Esportes"
  ),
  60023: label(
    "Google Play / Herramientas",
    "Google Play / Tools",
    "Google Play / Ferramentas"
  ),
  60024: label(
    "Google Play / Mapas y navegación",
    "Google Play / Maps & Navigation",
    "Google Play / Mapas e navegação"
  ),
  60025: label(
    "Google Play / Viajes",
    "Google Play / Travel & Local",
    "Google Play / Viagens e local"
  ),
  60026: label(
    "Google Play / Clima",
    "Google Play / Weather",
    "Google Play / Clima"
  ),
  60028: label(
    "Google Play / Juegos / Arcade",
    "Google Play / Games / Arcade",
    "Google Play / Jogos / Arcade"
  ),
  60029: label(
    "Google Play / Juegos / Mesa",
    "Google Play / Games / Board",
    "Google Play / Jogos / Tabuleiro"
  ),
  60030: label(
    "Google Play / Juegos / Cartas",
    "Google Play / Games / Card",
    "Google Play / Jogos / Cartas"
  ),
  60031: label(
    "Google Play / Juegos / Casual",
    "Google Play / Games / Casual",
    "Google Play / Jogos / Casual"
  ),
  60033: label(
    "Google Play / Juegos / Carreras",
    "Google Play / Games / Racing",
    "Google Play / Jogos / Corrida"
  ),
  60034: label(
    "Google Play / Juegos / Deportes",
    "Google Play / Games / Sports Games",
    "Google Play / Jogos / Esportes"
  ),
  60036: label(
    "Google Play / Juegos / Acción",
    "Google Play / Games / Action",
    "Google Play / Jogos / Ação"
  ),
  60037: label(
    "Google Play / Juegos / Aventura",
    "Google Play / Games / Adventure",
    "Google Play / Jogos / Aventura"
  ),
  60038: label(
    "Google Play / Juegos / Casino",
    "Google Play / Games / Casino",
    "Google Play / Jogos / Cassino"
  ),
  60039: label(
    "Google Play / Juegos / Educativos",
    "Google Play / Games / Educational",
    "Google Play / Jogos / Educativos"
  ),
  60040: label(
    "Google Play / Juegos / Familia",
    "Google Play / Games / Family",
    "Google Play / Jogos / Família"
  ),
  60041: label(
    "Google Play / Juegos / Música",
    "Google Play / Games / Music",
    "Google Play / Jogos / Música"
  ),
  60042: label(
    "Google Play / Juegos / Puzles",
    "Google Play / Games / Puzzle",
    "Google Play / Jogos / Quebra-cabeça"
  ),
  60043: label(
    "Google Play / Juegos / Rol",
    "Google Play / Games / Role Playing",
    "Google Play / Jogos / RPG"
  ),
  60044: label(
    "Google Play / Juegos / Simulación",
    "Google Play / Games / Simulation",
    "Google Play / Jogos / Simulação"
  ),
  60045: label(
    "Google Play / Juegos / Estrategia",
    "Google Play / Games / Strategy",
    "Google Play / Jogos / Estratégia"
  ),
  60046: label(
    "Google Play / Juegos / Trivia",
    "Google Play / Games / Trivia",
    "Google Play / Jogos / Trivia"
  ),
  60047: label(
    "Google Play / Juegos / Palabras",
    "Google Play / Games / Word",
    "Google Play / Jogos / Palavras"
  ),
  60048: label(
    "Google Play / Arte y diseño",
    "Google Play / Art & Design",
    "Google Play / Arte e design"
  ),
  60049: label(
    "Google Play / Autos y vehículos",
    "Google Play / Auto & Vehicles",
    "Google Play / Carros e veículos"
  ),
  60050: label(
    "Google Play / Belleza",
    "Google Play / Beauty",
    "Google Play / Beleza"
  ),
  60051: label(
    "Google Play / Citas",
    "Google Play / Dating",
    "Google Play / Encontros"
  ),
  60052: label(
    "Google Play / Eventos",
    "Google Play / Events",
    "Google Play / Eventos"
  ),
  60053: label(
    "Google Play / Comida y bebida",
    "Google Play / Food & Drink",
    "Google Play / Comida e bebida"
  ),
  60054: label(
    "Google Play / Hogar",
    "Google Play / House & Home",
    "Google Play / Casa e lar"
  ),
  60055: label(
    "Google Play / Crianza",
    "Google Play / Parenting",
    "Google Play / Criação dos filhos"
  ),
  60056: label(
    "Google Play / Familia",
    "Google Play / Family",
    "Google Play / Família"
  ),
  60057: label(
    "Google Play / Familia / Acción y aventura",
    "Google Play / Family / Action & Adventure",
    "Google Play / Família / Ação e aventura"
  ),
  60058: label(
    "Google Play / Familia / Juegos mentales",
    "Google Play / Family / Brain Games",
    "Google Play / Família / Jogos mentais"
  ),
  60059: label(
    "Google Play / Familia / Creatividad",
    "Google Play / Family / Creativity",
    "Google Play / Família / Criatividade"
  ),
  60060: label(
    "Google Play / Familia / Educación",
    "Google Play / Family / Education",
    "Google Play / Família / Educação"
  ),
  60061: label(
    "Google Play / Familia / Música y video",
    "Google Play / Family / Music & Video",
    "Google Play / Família / Música e vídeo"
  ),
  60062: label(
    "Google Play / Familia / Juego simbólico",
    "Google Play / Family / Pretend Play",
    "Google Play / Família / Faz de conta"
  ),
  60500: label("App Store", "Apple App Store", "App Store"),
  60501: label(
    "App Store / Libros",
    "Apple App Store / Book",
    "App Store / Livros"
  ),
  60502: label(
    "App Store / Negocios",
    "Apple App Store / Business",
    "App Store / Negócios"
  ),
  60503: label(
    "App Store / Educación",
    "Apple App Store / Education",
    "App Store / Educação"
  ),
  60504: label(
    "App Store / Entretenimiento",
    "Apple App Store / Entertainment",
    "App Store / Entretenimento"
  ),
  60505: label(
    "App Store / Finanzas",
    "Apple App Store / Finance",
    "App Store / Finanças"
  ),
  60506: label(
    "App Store / Juegos",
    "Apple App Store / Games",
    "App Store / Jogos"
  ),
  60507: label(
    "App Store / Salud y fitness",
    "Apple App Store / Health & Fitness",
    "App Store / Saúde e fitness"
  ),
  60508: label(
    "App Store / Estilo de vida",
    "Apple App Store / Lifestyle",
    "App Store / Estilo de vida"
  ),
  60509: label(
    "App Store / Medicina",
    "Apple App Store / Medical",
    "App Store / Medicina"
  ),
  60510: label(
    "App Store / Música",
    "Apple App Store / Music",
    "App Store / Música"
  ),
  60511: label(
    "App Store / Navegación",
    "Apple App Store / Navigation",
    "App Store / Navegação"
  ),
  60512: label(
    "App Store / Noticias",
    "Apple App Store / News",
    "App Store / Notícias"
  ),
  60513: label(
    "App Store / Quiosco",
    "Apple App Store / Newsstand",
    "App Store / Banca"
  ),
  60514: label(
    "App Store / Foto y video",
    "Apple App Store / Photo & Video",
    "App Store / Foto e vídeo"
  ),
  60515: label(
    "App Store / Productividad",
    "Apple App Store / Productivity",
    "App Store / Produtividade"
  ),
  60516: label(
    "App Store / Referencia",
    "Apple App Store / Reference",
    "App Store / Referência"
  ),
  60517: label(
    "App Store / Redes sociales",
    "Apple App Store / Social Networking",
    "App Store / Redes sociais"
  ),
  60518: label(
    "App Store / Deportes",
    "Apple App Store / Sports",
    "App Store / Esportes"
  ),
  60519: label(
    "App Store / Viajes",
    "Apple App Store / Travel",
    "App Store / Viagens"
  ),
  60520: label(
    "App Store / Utilidades",
    "Apple App Store / Utilities",
    "App Store / Utilitários"
  ),
  60521: label(
    "App Store / Clima",
    "Apple App Store / Weather",
    "App Store / Clima"
  ),
  60522: label(
    "App Store / Juegos / Acción",
    "Apple App Store / Games / Action",
    "App Store / Jogos / Ação"
  ),
  60523: label(
    "App Store / Juegos / Aventura",
    "Apple App Store / Games / Adventure",
    "App Store / Jogos / Aventura"
  ),
  60524: label(
    "App Store / Juegos / Arcade",
    "Apple App Store / Games / Arcade",
    "App Store / Jogos / Arcade"
  ),
  60525: label(
    "App Store / Juegos / Mesa",
    "Apple App Store / Games / Board",
    "App Store / Jogos / Tabuleiro"
  ),
  60526: label(
    "App Store / Juegos / Cartas",
    "Apple App Store / Games / Card",
    "App Store / Jogos / Cartas"
  ),
  60527: label(
    "App Store / Juegos / Casino",
    "Apple App Store / Games / Casino",
    "App Store / Jogos / Cassino"
  ),
  60528: label(
    "App Store / Juegos / Dados",
    "Apple App Store / Games / Dice",
    "App Store / Jogos / Dados"
  ),
  60529: label(
    "App Store / Juegos / Educativos",
    "Apple App Store / Games / Educational",
    "App Store / Jogos / Educativos"
  ),
  60530: label(
    "App Store / Juegos / Familia",
    "Apple App Store / Games / Family",
    "App Store / Jogos / Família"
  ),
  60531: label(
    "App Store / Juegos / Niños",
    "Apple App Store / Games / Kids",
    "App Store / Jogos / Crianças"
  ),
  60532: label(
    "App Store / Juegos / Música",
    "Apple App Store / Games / Music",
    "App Store / Jogos / Música"
  ),
  60533: label(
    "App Store / Juegos / Puzles",
    "Apple App Store / Games / Puzzle",
    "App Store / Jogos / Quebra-cabeça"
  ),
  60534: label(
    "App Store / Juegos / Carreras",
    "Apple App Store / Games / Racing",
    "App Store / Jogos / Corrida"
  ),
  60535: label(
    "App Store / Juegos / Rol",
    "Apple App Store / Games / Role Playing",
    "App Store / Jogos / RPG"
  ),
  60536: label(
    "App Store / Juegos / Simulación",
    "Apple App Store / Games / Simulation",
    "App Store / Jogos / Simulação"
  ),
  60537: label(
    "App Store / Juegos / Deportes",
    "Apple App Store / Games / Sports",
    "App Store / Jogos / Esportes"
  ),
  60538: label(
    "App Store / Juegos / Estrategia",
    "Apple App Store / Games / Strategy",
    "App Store / Jogos / Estratégia"
  ),
  60539: label(
    "App Store / Juegos / Trivia",
    "Apple App Store / Games / Trivia",
    "App Store / Jogos / Trivia"
  ),
  60540: label(
    "App Store / Juegos / Palabras",
    "Apple App Store / Games / Word",
    "App Store / Jogos / Palavras"
  ),
  60541: label(
    "App Store / Catálogos",
    "Apple App Store / Catalogs",
    "App Store / Catálogos"
  ),
  60542: label(
    "App Store / Quiosco / Noticias y política",
    "Apple App Store / Newsstand / News & Politics",
    "App Store / Banca / Notícias e política"
  ),
  60543: label(
    "App Store / Quiosco / Moda y estilo",
    "Apple App Store / Newsstand / Fashion & Style",
    "App Store / Banca / Moda e estilo"
  ),
  60544: label(
    "App Store / Quiosco / Hogar y jardín",
    "Apple App Store / Newsstand / Home & Garden",
    "App Store / Banca / Casa e jardim"
  ),
  60545: label(
    "App Store / Quiosco / Aire libre y naturaleza",
    "Apple App Store / Newsstand / Outdoors & Nature",
    "App Store / Banca / Ar livre e natureza"
  ),
  60546: label(
    "App Store / Quiosco / Deportes y ocio",
    "Apple App Store / Newsstand / Sports & Leisure",
    "App Store / Banca / Esportes e lazer"
  ),
  60547: label(
    "App Store / Quiosco / Automoción",
    "Apple App Store / Newsstand / Automotive",
    "App Store / Banca / Automóveis"
  ),
  60548: label(
    "App Store / Quiosco / Arte y fotografía",
    "Apple App Store / Newsstand / Arts & Photography",
    "App Store / Banca / Arte e fotografia"
  ),
  60549: label(
    "App Store / Quiosco / Bodas",
    "Apple App Store / Newsstand / Brides & Weddings",
    "App Store / Banca / Casamentos"
  ),
  60550: label(
    "App Store / Quiosco / Negocios e inversión",
    "Apple App Store / Newsstand / Business & Investing",
    "App Store / Banca / Negócios e investimentos"
  ),
  60551: label(
    "App Store / Quiosco / Revistas infantiles",
    "Apple App Store / Newsstand / Children's Magazines",
    "App Store / Banca / Revistas infantis"
  ),
  60552: label(
    "App Store / Quiosco / Informática e internet",
    "Apple App Store / Newsstand / Computers & Internet",
    "App Store / Banca / Informática e internet"
  ),
  60553: label(
    "App Store / Quiosco / Cocina, comida y bebida",
    "Apple App Store / Newsstand / Cooking, Food & Drink",
    "App Store / Banca / Culinária, comida e bebida"
  ),
  60554: label(
    "App Store / Quiosco / Manualidades",
    "Apple App Store / Newsstand / Crafts & Hobbies",
    "App Store / Banca / Artesanato e hobbies"
  ),
  60555: label(
    "App Store / Quiosco / Electrónica y audio",
    "Apple App Store / Newsstand / Electronics & Audio",
    "App Store / Banca / Eletrônicos e áudio"
  ),
  60556: label(
    "App Store / Quiosco / Entretenimiento",
    "Apple App Store / Newsstand / Entertainment",
    "App Store / Banca / Entretenimento"
  ),
  60557: label(
    "App Store / Quiosco / Salud, mente y cuerpo",
    "Apple App Store / Newsstand / Health, Mind & Body",
    "App Store / Banca / Saúde, mente e corpo"
  ),
  60558: label(
    "App Store / Quiosco / Historia",
    "Apple App Store / Newsstand / History",
    "App Store / Banca / História"
  ),
  60559: label(
    "App Store / Quiosco / Revistas literarias",
    "Apple App Store / Newsstand / Literary Magazines & Journals",
    "App Store / Banca / Revistas literárias"
  ),
  60560: label(
    "App Store / Quiosco / Interés masculino",
    "Apple App Store / Newsstand / Men's Interest",
    "App Store / Banca / Interesse masculino"
  ),
  60561: label(
    "App Store / Quiosco / Cine y música",
    "Apple App Store / Newsstand / Movies & Music",
    "App Store / Banca / Cinema e música"
  ),
  60562: label(
    "App Store / Quiosco / Crianza y familia",
    "Apple App Store / Newsstand / Parenting & Family",
    "App Store / Banca / Criação e família"
  ),
  60563: label(
    "App Store / Quiosco / Mascotas",
    "Apple App Store / Newsstand / Pets",
    "App Store / Banca / Animais de estimação"
  ),
  60564: label(
    "App Store / Quiosco / Profesional",
    "Apple App Store / Newsstand / Professional & Trade",
    "App Store / Banca / Profissional"
  ),
  60565: label(
    "App Store / Quiosco / Noticias regionales",
    "Apple App Store / Newsstand / Regional News",
    "App Store / Banca / Notícias regionais"
  ),
  60566: label(
    "App Store / Quiosco / Ciencia",
    "Apple App Store / Newsstand / Science",
    "App Store / Banca / Ciência"
  ),
  60567: label(
    "App Store / Quiosco / Adolescentes",
    "Apple App Store / Newsstand / Teens",
    "App Store / Banca / Adolescentes"
  ),
  60568: label(
    "App Store / Quiosco / Viajes",
    "Apple App Store / Newsstand / Travel & Regional",
    "App Store / Banca / Viagens"
  ),
  60569: label(
    "App Store / Quiosco / Interés femenino",
    "Apple App Store / Newsstand / Women's Interest",
    "App Store / Banca / Interesse feminino"
  ),
  60570: label(
    "App Store / Comida y bebida",
    "Apple App Store / Food & Drink",
    "App Store / Comida e bebida"
  ),
  60571: label(
    "App Store / Compras",
    "Apple App Store / Shopping",
    "App Store / Compras"
  ),
  60572: label(
    "App Store / Stickers",
    "Apple App Store / Stickers",
    "App Store / Figurinhas"
  ),
  60573: label(
    "App Store / Stickers / Emojis y expresiones",
    "Apple App Store / Stickers / Emoji & Expressions",
    "App Store / Figurinhas / Emojis e expressões"
  ),
  60574: label(
    "App Store / Stickers / Animales y naturaleza",
    "Apple App Store / Stickers / Animals & Nature",
    "App Store / Figurinhas / Animais e natureza"
  ),
  60575: label(
    "App Store / Stickers / Arte",
    "Apple App Store / Stickers / Art",
    "App Store / Figurinhas / Arte"
  ),
  60576: label(
    "App Store / Stickers / Celebraciones",
    "Apple App Store / Stickers / Celebrations",
    "App Store / Figurinhas / Celebrações"
  ),
  60577: label(
    "App Store / Stickers / Famosos",
    "Apple App Store / Stickers / Celebrities",
    "App Store / Figurinhas / Famosos"
  ),
  60578: label(
    "App Store / Stickers / Cómics y dibujos",
    "Apple App Store / Stickers / Comics & Cartoons",
    "App Store / Figurinhas / Quadrinhos e desenhos"
  ),
  60579: label(
    "App Store / Stickers / Comer y beber",
    "Apple App Store / Stickers / Eating & Drinking",
    "App Store / Figurinhas / Comer e beber"
  ),
  60580: label(
    "App Store / Stickers / Videojuegos",
    "Apple App Store / Stickers / Gaming",
    "App Store / Figurinhas / Videogames"
  ),
  60581: label(
    "App Store / Stickers / Cine y TV",
    "Apple App Store / Stickers / Movies & TV",
    "App Store / Figurinhas / Cinema e TV"
  ),
  60582: label(
    "App Store / Stickers / Música",
    "Apple App Store / Stickers / Music",
    "App Store / Figurinhas / Música"
  ),
  60583: label(
    "App Store / Stickers / Personas",
    "Apple App Store / Stickers / People",
    "App Store / Figurinhas / Pessoas"
  ),
  60584: label(
    "App Store / Stickers / Lugares y objetos",
    "Apple App Store / Stickers / Places & Objects",
    "App Store / Figurinhas / Lugares e objetos"
  ),
  60585: label(
    "App Store / Stickers / Deportes y actividades",
    "Apple App Store / Stickers / Sports & Activities",
    "App Store / Figurinhas / Esportes e atividades"
  ),
  60586: label(
    "App Store / Stickers / Niños y familia",
    "Apple App Store / Stickers / Kids & Family",
    "App Store / Figurinhas / Crianças e família"
  ),
  60587: label(
    "App Store / Stickers / Moda",
    "Apple App Store / Stickers / Fashion",
    "App Store / Figurinhas / Moda"
  ),
  61001: label(
    "Apps de Windows Phone",
    "Windows Phone Apps",
    "Apps do Windows Phone"
  ),
};

export const getGoogleAdsAppCategoryLabel = ({ id, name, language }) => {
  const lang = getLanguageFormatted(language);
  const mapped =
    GOOGLE_ADS_APP_CATEGORY_LABELS[Number(String(id).split("/").pop())];
  if (!mapped) return name || "";
  return mapped[lang] || mapped.en || name || "";
};
